<template>
  <div class="testarbre">
    <transition name="fade" mode="out-in">
      <div class="loading" v-if="loading">
        <div class="label">
          <i class="fa fa-cog fa-spin fa-3x fa-fw"></i> <br/>
          {{ message }}
        </div>
      </div>
    </transition>
    <b-container  :class="{fixe: ! selected}">
      <b-form-select v-model="selectedArbre" @change="getArbre($event)"  :options="options" :class="{fixe: ! selected}"></b-form-select>
      <debrief class="debrief" v-bind:isTest="true" v-if="selected"></debrief>
    </b-container>
  </div>
</template>
<script>
import Debrief from './Debrief'
export default {
  name: 'TestArbre',
  components: {
    Debrief
  },
  data () {
    return {
      options: [],
      arbres: [],
      selectedArbre: 0,
      selected: false,
      loading: false,
      message: '',
      login: [5603, 3179, 4926, 11506, 4220, 445, 480, 10636, 15701]
    }
  },
  methods: {
    getArbre: function (event) {
      if (event === 0) {
        this.selected = false
      } else {
        this.toggleLoader('Chargement de l\'arbre de débriefing en cours.')
        this.selected = false
        this.$http.get('recap/' + event).then(response => {
          this.response = response.json().then((data) => {
            localStorage.setItem('debrief', JSON.stringify(data))
            localStorage.setItem('arbre', JSON.stringify(this.arbres[event]))
            this.toggleLoader('')
            this.selected = true
          })
        }, () => {
          this.toggleLoader('')
          this.$toast.bottom('Une erreur est survenue lors de la récupération du débriefing')
        })
      }
    },
    toggleLoader: function (message) {
      this.message = message
      this.loading = !this.loading
    }
  },
  mounted: function () {
    this.toggleLoader('Téléchargement des arbres en cours')
    this.$http.get('arbre/testarbres').then(
      response => {
        response.json().then(result => {
          this.options.push({value: 0, text: 'Choisissez un arbre'})
          let data = result.arbreTest
          for (let i in data) {
            let beta = ''
            if (data[i].beta === 1 && this.login.indexOf(result.login) !== -1) {
              beta = ' (BETA) '
            } else if (data[i].beta === 1 && this.login.indexOf(result.login) === -1) {
              continue
            }
            this.options.push({
              value: data[i]['id_type_question'],
              text: data[i]['nom_type_intervention'] + beta + ' --- ' + data[i]['etat']
            })
            this.arbres[data[i]['id_type_question']] = {id: data[i]['id_type_intervention'], etat: data[i]['etat']}
          }
          this.toggleLoader('')
        })
      },
      err => {
        this.toggleLoader('')
        this.$toast.bottom('Une erreur est survenue lors de la récuperation des arbres de test')
        console.log(err)
      }
    )
  }
}
</script>
<style scoped>
  .testarbre {
    margin-top: 110px;
    padding-top: 30px;
  }
  .debrief-content-test{
    margin-top: 30px !important;
    padding-top: 0px;
  }
  .form-control{
    font-size: 17px;
    font-weight: bold;
    text-align: center;
  }
  .form-control:focus {
    border-color: rgb(230, 68, 68);
    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.075) inset, 0px 0px 8px rgb(230, 68, 68, 0.5);
  }
  .debrief{
    padding-top: 40px;
  }
  .loading{
    position: fixed;
    text-align: center;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0,0,0,.7);
    z-index: 9999;
    color: white;
    top: 55px;
  }
  .loading > .label{
    padding-top: 35vh;
  }
  .fixe{
    max-height: 80vh;
  }
</style>



// WEBPACK FOOTER //
// src/components/TestArbre.vue